class InteractiveDimensions {
    constructor(data) {
        this.width = data.width;
        this.height = data.height;
    }
}

export default InteractiveDimensions;